
















































































































import Vue from "vue";
import store from "@/store";
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";

export default Vue.extend({

  name: 'TeamViewpointButton',


  components: {},

  props: {
    team: {
      type: Object,
      default:  () => {},
    },
    viewpoints: {
      type: Array,
      default:  () => [],
    },
  },

  created() {
    if (Object.keys(this.team).length) {
      if (this.team.viewpoints.length) {
        this.selected = [];
        for (const viewpointId of this.team.viewpoints) {
          let item: any[] = _.filter(this.viewpoints, {'viewpointId': viewpointId});
          if (item.length) {
            this.selected.push(item[0]);
          }
        }
        this.viewpointsStart = this.team.viewpoints;
      }
    }
  },

  data() {
    return {
      dialog: false,
      isUpdating: true,
      singleSelect: false,
      viewpointsStart: [] as any,
      selected: [] as any,
      headers: [
        {
          text: 'NAME',
          align: 'left',
          // sortable: false,
          value: 'name',
        },
        {
          text: 'CREATED',
          value: 'creationTimestamp',
        },
      ],
    };
  },

  watch: {
    dialog(newVal, oldVal) {
      if (newVal) {
        console.log('[ Team Invite Button > Starting Viewpoints ]');
        console.log(this.viewpointsStart);
        console.log('[ Team Invite Button > Selected Viewpoints ]');
        console.log(this.viewpointsEnd);
      } else {
        this.selected = [];
        if (this.team.viewpoints.length) {
          for (const viewpointId of this.team.viewpoints) {
            let item: any[] = _.filter(this.viewpoints, {'viewpointId': viewpointId});
            if (item.length) {
              this.selected.push(item[0]);
            }
          }
        }
        console.log('[ watch() > dialog() > this.selected ]: ');
        console.log(this.selected);
      }
    },
    team(newVal, oldVal) {
      this.selected = [];
      if (this.team.viewpoints.length) {
        for (const viewpointId of this.team.viewpoints) {
          let item: any[] = _.filter(this.viewpoints, {'viewpointId': viewpointId});
          if (item.length) {
            this.selected.push(item[0]);
          }
        }
      }
      this.viewpointsStart = this.team.viewpoints;
      console.log('[ watch() > team() > this.team.name ]: ' + this.team.name);
    },
  },

  computed: {
    // mix the getters into computed
    ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
    getTeamId(): string {
      if (Object.keys(this.team).length) {
        return this.team.teamId;
      } else {
        return '';
      }
    },
    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
        return '';
      }
    },
    viewpointsEnd(): any[] {
      return _.map(this.selected, 'viewpointId');
    },
    updatePayload(): any {
      let payload: any = {
        addViewpoints: [],
        removeViewpoints: [],
        team: {}
      };
      const viewpointsStart: any[] = this.viewpointsStart;
      const viewpointsEnd: any[] = this.viewpointsEnd;
      const addViewpoints: any[] = viewpointsEnd.filter( (v: any) => !viewpointsStart.includes(v) );
      payload['addViewpoints'] = addViewpoints;
      const removeViewpoints: any[] = viewpointsStart.filter( (v: any) => !viewpointsEnd.includes(v) );
      payload['removeViewpoints'] = removeViewpoints;
      payload['team'] = this.team;
      return payload;
    }
  },

  methods: {

    formatDate(timestampString: any): string {
      let newDate: Date = new Date(timestampString);
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

    updateTeamViewpoints() {
      if (this.updatePayload.addViewpoints.length || this.updatePayload.removeViewpoints.length) {
        console.log('[ updateTeamViewpoints() ]: ');
        console.log(this.updatePayload);
        store.dispatch('updateTeamViewpoints', this.updatePayload);
      }
      this.dialog = false;
    },

  },

});
